import { PositionInterface } from 'types';
import { stringOrNumberHelper } from './stringOrNumberHelper';

export function positionDecorator({
	bottom,
	left,
	position,
	right,
	top,
}: PositionInterface) {
	let response = '';
	if (position) {
		response += `position: ${position};`;
		if (bottom !== undefined) {
			response += `bottom: ${stringOrNumberHelper(bottom)};`;
		}
		if (left !== undefined) {
			response += `left: ${stringOrNumberHelper(left)};`;
		}
		if (right !== undefined) {
			response += `right: ${stringOrNumberHelper(right)};`;
		}
		if (top !== undefined) {
			response += `top: ${stringOrNumberHelper(top)};`;
		}
	}
	return response;
}
